import React from 'react';
import OnboardingPageOverlay from '../../shared/OnboardingPageOverlay';
import PurchaseOrderOnboardingStep from './PurchaseOrderOnboardingStep';

const PurchaseOrderOnboardingOverlay: React.FC = () => (
  <OnboardingPageOverlay stepId="purchase-order">
    {(onDismiss) => <PurchaseOrderOnboardingStep onDismiss={onDismiss} />}
  </OnboardingPageOverlay>
);

export default PurchaseOrderOnboardingOverlay;
